import { useCallback, useEffect, useMemo, useState } from "react";

import stringToHtmlParser from 'html-react-parser';
import { Select as TWSelect, Col, Label, Row } from "twyne-new.ui";

import Option from "./Option";
import OptionProperties from "./Properties";

function getContainerStyle(horizontalPadding) {
  const containerStyle = {}
  if (horizontalPadding) {
    containerStyle.paddingLeft = `${horizontalPadding}`;
    containerStyle.paddingRight = `${horizontalPadding}`;
  }

  return containerStyle;
}

function ConsentText({ consentTextActive, consentText }) {
  if (!consentTextActive) return null;

  return <Label>
    {stringToHtmlParser(consentText || '')}
  </Label>
}

function Select({ data }) {
  const { answers = [], templateCols = 2, templateRows = 2, templateType, skipOption, skipAnswer, isMultipleAnswers } = data
  const allAnswers = skipOption && skipAnswer && !isMultipleAnswers ? [...answers, skipAnswer] : answers
  const selectOptions = templateType === 'only-dropdown' ? allAnswers : allAnswers.slice(templateCols * templateRows)
  const isRenderSelect = templateType !== 'only-buttons' && selectOptions.length > 0

  if (!isRenderSelect) return null;

  return <Row className="mt-2 flex justify-center" >
    <Col size="6">
      <TWSelect options={selectOptions?.map(answer => ({ label: answer.answer, value: answer.key }))} />
    </Col>
  </Row>
}

function Options({ disabled, onClickOption, data }) {
  const [rows, setRows] = useState([]);
  const { answers = [], skipOption, skipAnswer, isMultipleAnswers, templateCols = 2, templateRows = 2, templateType, buttonPadding = 3, horizontalPadding } = data;
  const isRenderOption = templateType !== 'only-dropdown'
  const allAnswers = useMemo(() => skipOption && skipAnswer && !isMultipleAnswers ? [...answers, skipAnswer] : answers, [answers, skipOption, skipAnswer, isMultipleAnswers])
  const answerLength = allAnswers.length;

  const genarateRows = useCallback(() => {
    if (answerLength > 0) {
      const answersRows = templateType === 'only-buttons' ? allAnswers : allAnswers.slice(0, templateCols * templateRows);
      const rows = answersRows.reduce((acc, answer, index) => {
        const row = Math.floor(index / templateCols);
        if (!acc[row]) acc[row] = [];
        acc[row].push({ ...answer, index });
        return acc;
      }, [])

      setRows(rows);
    }
  }, [answerLength, templateCols, templateRows, allAnswers, templateType])

  useEffect(() => {
    genarateRows()
  }, [genarateRows])

  if (!isRenderOption) return null;

  const containerStyle = getContainerStyle(horizontalPadding);

  return <div style={containerStyle}>
    {rows.map((row, rowIndex) => <Row key={rowIndex} className="mb-2">
      {row.map((answer, colIndex) => <Col size={Math.floor(12 / row.length)} key={colIndex}>
        <Option answer={answer} index={answer.index} onClick={onClickOption} buttonPadding={buttonPadding} disabled={disabled} />
      </Col>)}
    </Row>)}
  </div>
}

export default function ButtonAndDropdown({ data, onChange, disabled }) {
  const { answers = [], question, consentTextActive, consentPosition, consentText, skipOption, skipAnswer, isMultipleAnswers } = data;
  const isConsentBefore = consentPosition === 'before';
  const [selectedAnswer, setSelectedAnswer] = useState(null)

  const allAnswers = useMemo(() => (
    skipOption && skipAnswer && !isMultipleAnswers ? [...answers, skipAnswer] : answers
  ), [answers, skipOption, skipAnswer, isMultipleAnswers])

  const handleClickOption = index => {
    setSelectedAnswer(index)
  }

  const handlePropertiesChange = useCallback((field, value) => {
    if (field === 'answers' && skipOption && !isMultipleAnswers) {
      const regularAnswers = value.filter(a => a.key !== '$skip')
      const updatedSkip = value.find(a => a.key === '$skip')
      onChange('answers', regularAnswers)
      if (updatedSkip) onChange('skipAnswer', updatedSkip)
    } else {
      onChange(field, value)
    }
  }, [onChange, skipOption, isMultipleAnswers])

  if (answers.length === 0) return null;

  return <>
    <Row>
      <Col size="12" className="flex justify-center">
        <h3>{stringToHtmlParser(question || '')}</h3>
      </Col>
    </Row>
    {isConsentBefore && <Row className="mt-2">
      <Col size="12" className="flex justify-center">
        <ConsentText consentTextActive={consentTextActive} consentText={consentText} />
      </Col>
    </Row>}
    <Options disabled={disabled} onClickOption={handleClickOption} data={data} />
    <Select data={data} />
    {!isConsentBefore && <Row className="mt-2" >
      <Col size="12" className="flex justify-center">
        <ConsentText consentTextActive={consentTextActive} consentText={consentText} />
      </Col>
    </Row>}
    <OptionProperties selectedAnswer={selectedAnswer} onChange={handlePropertiesChange} disabled={disabled} open={selectedAnswer !== null} onClose={() => setSelectedAnswer(null)} answers={allAnswers} />
  </>
}
